let lastKey = 0;

export function nextPromptBoxKey(): number {
  lastKey += 1;

  return lastKey;
}
